import React from 'react';
import {supportsPassiveOption} from 'utils/utils';
import './index.scss';

export default class MiniProgram extends React.Component {
    passive = supportsPassiveOption ? {
        passive: false
    } : false;
    componentDidMount() {
        document.body.addEventListener('touchmove', this.lockScroll, this.passive);
    }
    componentWillUnmount() {
        document.body.removeEventListener('touchmove', this.lockScroll, this.passive);
    }
    close = e => {
        if (e.target === e.currentTarget) {
            this.props.close();
        }
    }
    lockScroll(e) {
        e.preventDefault();
    }
    render() {
        return (
            <div className="g-flexbox-column qrcode" onClick={this.close}>
                {this.props.tip ? <div className="tip">{this.props.tip}</div> : null}
                <img className={`${this.props.tip ? 'qrcode-pic tipImg' : 'qrcode-pic'}`} src={this.props.url} />
                <i className="yo-ico qrcode-close" onClick={this.close}>&#xf3f4;</i>
            </div>
        );
    }
}